import React from "react";
import { Helmet } from "react-helmet-async";
import Title from "../title/title.component";
import AboutMenu from "./dropdown-items/nav-about-menu";
import { useTranslation } from "react-i18next";

import { StyledContainer } from "../styles/styled-container";
import { StyledNavInformationPageWrapper } from "./styled-info-page";
import { helmetHtmlByLang } from "../../utils/consts.util";

const NavInformationPage = () => {
  const { t } = useTranslation("navigations");

  return (
    <StyledContainer>
      <Helmet>
        <title>{t("usefulLinks.title")} - Coin24</title>
        <link rel="alternate" href={'https://' + window.location.hostname + '/info'} hrefLang={helmetHtmlByLang.ru} />
        <link rel="alternate" href={'https://' + window.location.hostname + '/ua/info'} hrefLang={helmetHtmlByLang.ua} />
        <meta name="robots" content="noindex" />
      </Helmet>
      <StyledNavInformationPageWrapper>
        <Title
          as="h2"
          title={t("usefulLinks.title")}
          description={t("usefulLinks.subTitle")}
          className="info-page__title"
        />
        <div className="info-page__link-wrapper">
          <AboutMenu className="separated-page" />
        </div>
      </StyledNavInformationPageWrapper>
    </StyledContainer>
  );
};

export default NavInformationPage;